import id from './id.js';
import initialState from './initial-state.js';
import selectorDefinitions from './selectors/index.js';
const walletReduxDefinition = {
    id,
    type: 'redux-module',
    initialState,
    eventReducers: {
        start: (state, payload) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    locked: payload.isLocked,
                },
            };
        },
        backedUp: (state, payload) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    backedUp: payload,
                },
            };
        },
        lock: (state) => ({
            ...state,
            data: {
                ...state.data,
                locked: true,
            },
        }),
        unlock: (state) => ({
            ...state,
            data: {
                ...state.data,
                locked: false,
            },
        }),
    },
    selectorDefinitions,
};
export default walletReduxDefinition;
